import React, { useState, useEffect, useRef } from "react";
import "../../../Content/Styles/SuperKlubWidget.less";
import RiveComponent from "../Shared/RiveComponent";
import Flickity from 'flickity';
import 'flickity/css/flickity.css';

const prefix = "super-klub_";

const arrow_icon_path = "M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z";

const text = {
    title: "SuperKlub Izazovi",
    subtitle: "SuperKlub ima i svoju posebnu valutu - Supere.",
    description: "Sakupljaj Supere rješavanjem izazova i zamijeni ih za nagrade ili bonuse koje želiš. Pridruži se zajednici casino igrača i sportskih znalaca, aktivno igraj i uživaj u SuperSport ponudi i SuperCasino igricama, a mi ćemo se pobrinuti za super nagrade. Ti igraš, mi nagrađujemo!",
    play: "Igraj",
    findMore: "Svi Izazovi",
};

const activeText = "Aktivna";

const ArrowIcon = () => (
    <svg style={{ left: "0rem", top: "0px", position: "relative" }} width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
        <path d={arrow_icon_path} />
    </svg>
);

const LearnMoreButton = ({ href }) => (
    <button className={`${prefix}learn_more`}>
        <span className={`${prefix}learn_more_icon`}>
            <ArrowIcon />
        </span>
        <a className={`${prefix}learn_more_anchor`} href={href}>
            {text.findMore}
        </a>
    </button>
);

const ChallengeCard = ({ challenge }) => {
    const progressPercent = challenge?.steps > 0
        ? (challenge?.completed_steps ?? 0) / challenge.steps * 100
        : (challenge?.progress ?? 0) * 100;

    const progressLabel = challenge?.steps > 0
        ? `IZVRŠENO ${challenge?.completed_steps ?? 0}/${challenge.steps}`
        : `IZVRŠENO ${(challenge?.progress ?? 0) * 100}%`;

    return (
        <div className={`${prefix}challenge`}>
            <div
                className={`${prefix}challenge_image`}
                style={{ backgroundImage: challenge?.settings?.icon_url ? `url('${challenge.settings.icon_url}')` : 'none' }}
            >
                <span className={`${prefix}challenge_coin`}>
                    <span className={`${prefix}challenge_coin_amount`}>{challenge?.points ?? 0}</span>
                </span>
            </div>
            <div className={`${prefix}challenge_body`}>
                <div className={`${prefix}challenge_title`}>{challenge?.title ?? ''}</div>
                <div className={`${prefix}challenge_progress_title`}>{progressLabel}</div>
                <div className={`${prefix}challenge_progress_bar`}>
                    <div className={`${prefix}challenge_progress`} style={{ width: `${progressPercent}%` }} />
                </div>
                <div className={`${prefix}challenge_description`}>{challenge?.description ?? ''}</div>
                <button className={`${prefix}challenge_play`}>
                    <a
                        className={`${prefix}challenge_play_anchor`}
                        onClick={() => (window.location = challenge?.settings?.mobile_url)}
                    >
                        {text.play}
                    </a>
                </button>
            </div>
        </div>
    );
};

export const SuperKlubWidget = ({ isLoggedIn, promoPage = false }) => {
    const [challenges, setChallenges] = useState([]);
    const carouselRef = useRef(null);
    const flickityInstance = useRef(null);
    const hasAnyChallenges = challenges.length > 0;
    const fullChallengesUrl = `${casino.config.urls.mobile}promotions/superklub`;

    // Data fetch, HizmanB
    useEffect(() => {
        if (!isLoggedIn) return;
        casino.repos.superklubLoyaltyRepo.get().then((result) => {
            setChallenges(result.data.challenges[0].challenges);
        });
    }, [isLoggedIn]);

    // Flickity slider, HizmanB
    useEffect(() => {
        if (!carouselRef.current || challenges.length === 0) return;

        flickityInstance.current = new Flickity(carouselRef.current, {
            cellAlign: 'left',
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            cellSelector: `.${prefix}challenge`,
        });

        return () => flickityInstance.current?.destroy();
    }, [challenges]);

    if (isLoggedIn && hasAnyChallenges) {
        return (
            <div className={promoPage ? `${prefix}widget_promo` : `${prefix}widget`}>
                {promoPage && <div className={`${prefix}active_light`}>
                    <div className={`${prefix}info_container`}>
                        <div className={`${prefix}info_arrow`} />
                        <div className={`${prefix}info_message`}>
                            {activeText}
                        </div>
                    </div>
                </div>
                }
                <div className={`${prefix}background`} />
                <div className={`${prefix}content_holder`}>
                    <div className={`${prefix}illustration_holder`}>
                        <div className={`${prefix}illustration`} />
                    </div>

                    <div className={`${prefix}floating_title_holder`}>
                        <div className={`${prefix}floating_title`}>Dnevni {text.title}</div>
                    </div>

                    <div className={`${prefix}body_holder`}>
                        <div className={`${prefix}body_wrapper`}>
                            <div className={`${prefix}body`} ref={carouselRef}>
                                {challenges.map((challenge, index) => (
                                    <ChallengeCard
                                        key={`${challenge?.tournamentID ?? index}-${index}`}
                                        challenge={challenge}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className={`${prefix}button_holder`}>
                        <LearnMoreButton href={fullChallengesUrl} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={promoPage ? `${prefix}widget_promo` : `${prefix}widget`}>
            {promoPage && <div className={`${prefix}active_light`}>
                <div className={`${prefix}info_container`}>
                    <div className={`${prefix}info_arrow`} />
                    <div className={`${prefix}info_message`}>
                        {activeText}
                    </div>
                </div>
            </div>
            }
            <div className={`${prefix}background`} />
            <div className={`${prefix}illustration`} />

            <div className={`${prefix}section_info`}>
                <div className={`${prefix}title`}>{text.title}</div>
                <div className={`${prefix}subtitle`}>{text.subtitle}</div>
                <div className={`${prefix}description`}>{text.description}</div>
            </div>

            <LearnMoreButton href={fullChallengesUrl} />
        </div>
    );
};